import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { FocusEvent } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputText, DisplayEvent, InputDateTime, DateComp } from '@/components';
import { type DateType } from '@/utilities/dateutils';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class FocusEventGuiDef extends GuiDef<FocusEvent> {
    constructor() {
        super('FocusEvent');

        const Name = new FieldDef<FocusEvent>();
        Name.Name = 'Name';
        Name.FieldName = 'Name';
        Name.DefinedFor = 'Both';
        Name.TranslationKey = 'focusevent.name';
        Name.Editable = true;
        Name.Filterable = true;
        Name.Sortable = true;
        Name.CssClasses = '';
        Name.value = (focusevent) => focusevent.Name;
        Name.setValue = (focusevent, value) => (focusevent.Name = value);
        Name.DetailEditor = markRaw(InputText);
        Name.DetailEditorProps = {};
        Name.CellEditor = markRaw(InputText);
        Name.CellEditorProps = {};
        Name.CellRenderer = markRaw(DisplayEvent);
        Name.CellRendererProps = {};
        Name.Validator = null;
        Name.SortDirection = undefined;
        Name.cellClassRules = undefined;
        Name.MinWidth = 300;
        Name.MaxWidth = 400;
        Name.Tooltip = null;
        this.Fields.push(Name);

        const Date = new FieldDef<FocusEvent>();
        Date.Name = 'Date';
        Date.FieldName = 'Date';
        Date.DefinedFor = 'Both';
        Date.TranslationKey = 'focusevent.date';
        Date.Editable = true;
        Date.Filterable = true;
        Date.Sortable = true;
        Date.CssClasses = '';
        Date.value = (focusevent) => focusevent.Date;
        Date.setValue = (focusevent, value) => (focusevent.Date = value);
        Date.DetailEditor = markRaw(InputDateTime);
        Date.DetailEditorProps = { format: 'DATE' as DateType };
        Date.CellEditor = markRaw(InputDateTime);
        Date.CellEditorProps = { format: 'DATE' as DateType };
        Date.CellRenderer = markRaw(DateComp);
        Date.CellRendererProps = { format: 'DATE' as DateType };
        Date.Validator = null;
        Date.SortDirection = undefined;
        Date.cellClassRules = undefined;
        Date.MinWidth = 110;
        Date.MaxWidth = 110;
        Date.Tooltip = null;
        this.Fields.push(Date);
    }

    public async LoadDependencies() {}
}
